(() => {
  const selectors = {
    wrapper: '[data-product-description-toggle]',
    preview: '[data-product-description-preview]',
    content: '[data-product-description-content]',
    button: '[data-product-description-button]',
    readMore: '[data-product-description-read-more]',
    showLess: '[data-product-description-show-less]',
  };

  const initDescriptionToggle = (wrapper) => {
    const preview = wrapper.querySelector(selectors.preview);
    const content = wrapper.querySelector(selectors.content);
    const button = wrapper.querySelector(selectors.button);
    const readMore = wrapper.querySelector(selectors.readMore);
    const showLess = wrapper.querySelector(selectors.showLess);

    if (!preview || !content || !button || !readMore || !showLess) return;
    if (button.dataset.productDescriptionBound === 'true') return;

    button.dataset.productDescriptionBound = 'true';
    button.addEventListener('click', () => {
      const isExpanded = wrapper.classList.toggle('is-expanded');

      wrapper.classList.toggle('is-collapsed', !isExpanded);
      preview.hidden = isExpanded;
      content.hidden = !isExpanded;
      button.setAttribute('aria-expanded', String(isExpanded));
      readMore.hidden = isExpanded;
      showLess.hidden = !isExpanded;
    });
  };

  const initAllDescriptionToggles = () => {
    document.querySelectorAll(selectors.wrapper).forEach(initDescriptionToggle);
  };

  document.addEventListener('DOMContentLoaded', initAllDescriptionToggles);
  document.addEventListener('shopify:section:load', initAllDescriptionToggles);
})();
